module.exports = __webpack_public_path__ + "img/carryon.1ee58d7f.png";